import { Greeks } from './gen/greeks_pb';
import { AssistantAnswer, InvestorSummaryMessageWrapper } from './gen/investorSummaries_pb';
import { Price } from './gen/pricing_pb';
import { GreeksItem } from './greeks.model';
import { AssistantAnswerItem, InvestorSummaryMessageItem } from './investor-summaries.model';
import { PricingItem } from './pricing.model';

export const grpcGreeksToGreeksItem = (greek: Greeks): GreeksItem => ({
  source: greek.Source,
  currency: greek.Currency,
  clientid: Number(greek.ClientId),
  pricetype: greek.PriceType,
  value: greek.Value ?? null,
  evaltime: greek.EvalTime ? Number(greek.EvalTime.seconds) : 0,
  securitymarketid: greek.SecurityMarketId,
});

export const grpcPricingToPricingItem = (price: Price): PricingItem => ({
  source: price.Source,
  currency: price.Currency,
  clientid: Number(price.ClientId),
  pricetype: price.PriceType,
  value: price.Value ?? null,
  evaltime: price.EvalTime ? Number(price.EvalTime.seconds) : 0,
  securitymarketid: price.SecurityMarketId,
});

export const grpcInvestorSummaryMessageToInvestorSummaryItem = ({
  InvestorSummary,
  InvestorContactSummary,
}: InvestorSummaryMessageWrapper): InvestorSummaryMessageItem => ({
  investorSummary: InvestorSummary
    ? {
        investorId: InvestorSummary.InvestorId,
        summary: InvestorSummary.Summary,
        errorMessage: InvestorSummary.ErrorMessage,
      }
    : null,
  investorContactSummary: InvestorContactSummary
    ? {
        investorId: InvestorContactSummary.InvestorId,
        contactId: InvestorContactSummary.ContactId,
        summary: InvestorContactSummary.Summary,
        errorMessage: InvestorContactSummary.ErrorMessage,
      }
    : null,
});

export const grpcAssistantAnswerToAssistantAnswerItem = (answer: AssistantAnswer): AssistantAnswerItem => ({
  chatId: answer.ChatId,
  inReplyTo: answer.InReplyTo,
  messageId: answer.MessageId ?? null,
  summary: answer.Summary ?? null,
  errorMessage: answer.ErrorMessage ?? null,
});
